import React from 'react';
import styles from '../dramelinaferrari2/dramelinaferrari2.module.scss';
import Background from './src/background-links.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MagazineIcon from '../../icons/magazineIcon.tsx';

const Dramelinaferrari2: React.FC = () => {
    return (
        <div className={styles.dramelinaferrari2}>
            <div className={styles["body-thunder"]} style={{
                backgroundImage: `url(${Background})`
            }}>
                <div
                    className={styles["container-thunder"]}
                >
                    <h1 className="pt-2">Dra Melina Ferrari</h1>
                    <div className={styles.links}>
                        <>
                            <LinkPersonalizado7
                                href="https://www.instagram.com/dramelinaferrari?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                title="INSTAGRAM"
                                icon={<InstagramIcon marginTop={true} height="32" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                            <LinkPersonalizado7
                                href="https://wa.me/5517992024340?text=Olá, gostaria de agendar um horário."
                                title="AGENDAR WHATSAPP"
                                icon={<WhatsappIcon height="40" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                            <LinkPersonalizado7
                                href="https://maps.app.goo.gl/j58ZzD1auyUv6GC18"
                                title="LOCALIZAÇÃO"
                                icon={<MapsIcon height="38" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                            <LinkPersonalizado7
                                href="https://wa.me/5517992024340?text=Olá, gostaria de mais informações sobre cursos/mentorias."
                                title="CURSOS MENTORIAS"
                                icon={<MagazineIcon height="34" color="#ffffff" />}
                                colorText="#cbb353"
                                spaceBetween={true}
                            />
                            {/* <LinkPersonalizado7
                                href="#"
                                title="ACESSE CATÁLOGO"
                                icon={<CatalogIcon height="36" color="#ffffff" />}
                                colorText="#cbb353"
                            /> */}
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dramelinaferrari2;
